import React from 'react';
export function CandidatForm() {
  return <div className="bg-white p-4 md:p-6 rounded-3xl shadow-xl border border-slate-100" data-id="element-43" data-mp="3djdfsttqq4q8">
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdRLYT0VfO_LX-YYiSPQlqEqRBbh85E9r9tEh_ECt_v__4ISQ/viewform?embedded=true" width="100%" height="2532" frameBorder={0} marginHeight={0} marginWidth={0} title="Formulaire de candidature — Zillenium Alternance" className="w-full rounded-2xl" data-id="element-44" data-mp="1hrn3y0xvl85g">
        Chargement…
      </iframe>
    </div>;
}